import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import RevenueSection from '@/pages/home/components/RevenueSection';
import RevenueCalculator from '@/pages/franchise/revenue/components/RevenueCalculator';
import { Link } from 'react-router-dom';

function RevenueHero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => { const t = setTimeout(() => setVisible(true), 100); return () => clearTimeout(t); }, []);

  return (
    <section className="relative flex items-center overflow-hidden bg-[#1A1A1A]" style={{ minHeight: '620px' }}>
      {/* 배경 이미지 */}
      <img
        src="https://public.readdy.ai/ai/img_res/4ac25fb1d31d9e8aabd008f2807bbf6c.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
        style={{ opacity: 0.55 }}
      />
      {/* 그라디언트 오버레이 */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(to bottom, rgba(10,10,10,0.5) 0%, rgba(10,10,10,0.35) 40%, rgba(10,10,10,0.75) 100%)' }}
      />
      {/* 골드 상단 라인 */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#C9A96E]" />

      <div
        className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-16 pt-36 pb-20 md:pt-40 md:pb-24 text-center"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)',
          transition: 'opacity 0.9s ease-out, transform 0.9s ease-out',
        }}
      >
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 mb-10">
          <Link to="/franchise" className="text-[10px] tracking-[0.3em] uppercase text-white/40" style={{ textDecoration: 'none' }}>
            Franchise
          </Link>
          <span className="text-white/20">/</span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#C9A96E]">Revenue Model</span>
        </div>

        {/* 타이틀 */}
        <h1
          className="text-[36px] md:text-[58px] text-white mb-6 leading-snug break-keep"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, letterSpacing: '0.04em' }}
        >
          가맹점 예상 수익
        </h1>

        {/* 설명 텍스트 */}
        <p
          className="text-sm md:text-[15px] leading-relaxed break-keep max-w-[300px] md:max-w-none mx-auto"
          style={{ color: 'rgba(255,255,255,0.6)' }}
        >
          1인 프리미엄 아티스트 모델의 압도적 수익성을{' '}
          투명한 데이터와 시각적 차트로 직접 확인하세요.
        </p>

        {/* 구분선 */}
        <div className="w-14 h-px mx-auto my-10" style={{ background: 'rgba(201,169,110,0.5)' }} />

        {/* 통계 3개 */}
        <div className="flex flex-wrap items-center justify-center gap-y-8 gap-x-10 md:gap-x-16">
          {[
            { value: '1,650', unit: '만 원', label: '월 평균 매출' },
            { value: '75', unit: '%', label: '순이익률' },
            { value: '1,250', unit: '만 원', label: '월 예상 순이익' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-[28px] md:text-[36px] font-semibold text-white mb-2 leading-none"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {stat.value}
                <span className="text-sm md:text-base font-normal ml-1 text-[#C9A96E]">{stat.unit}</span>
              </div>
              <div className="text-[10px] tracking-[0.25em] uppercase" style={{ color: 'rgba(255,255,255,0.35)' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FranchiseCta() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 text-center">
        <div className="text-[11px] tracking-[0.35em] uppercase text-[#C9A96E] mb-5">
          Next Step
        </div>
        <h2
          className="text-[26px] md:text-[36px] text-[#1A1A1A] mb-5 leading-snug break-keep"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400 }}
        >
          지금 바로 창업 상담을 시작하세요
        </h2>
        <p
          className="text-sm text-[#888] leading-relaxed break-keep max-w-[280px] md:max-w-[420px] mx-auto mb-12"
          style={{ lineHeight: 1.8 }}
        >
          수익 시뮬레이션 이상의 실제 데이터와 맞춤 창업 플랜을{' '}
          선율 본사 전문 컨설턴트가 직접 안내해 드립니다.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/franchise/guide"
            className="px-8 py-3.5 bg-[#1A1A1A] text-white text-[11px] tracking-[0.2em] uppercase font-medium rounded-full whitespace-nowrap"
            style={{ textDecoration: 'none' }}
          >
            창업 안내 보기
          </Link>
          <Link
            to="/community/inquiry"
            className="px-8 py-3.5 border border-[#1A1A1A] text-[#1A1A1A] text-[11px] tracking-[0.2em] uppercase font-medium rounded-full whitespace-nowrap"
            style={{ textDecoration: 'none' }}
          >
            가맹 문의하기
          </Link>
        </div>
      </div>
    </section>
  );
}

export default function FranchiseRevenuePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <RevenueHero />
        <RevenueSection />
        <RevenueCalculator />
        <FranchiseCta />
      </main>
      <Footer />
    </div>
  );
}